import { api } from '@/api'
import type { ServiceAccountResponse } from '@/api/serviceAccounts.types'
import type { ServiceAccount, ServiceAccountInput } from '../types'
import { toNewRequest, toServiceAccount, toUpdateRequest } from '../transform/serviceAccountTransformer'

// The IDP admin service accounts API, reached through the BFF proxy. Domain
// types out; the wire shape is contained at this boundary.
const BASE = '/v1/admin/serviceaccounts'

// GET /v1/admin/serviceaccounts → ServiceAccountResponse[].
export function listServiceAccounts(): Promise<ServiceAccount[]> {
  return api.get<ServiceAccountResponse[]>(BASE).then((accounts) => accounts.map(toServiceAccount))
}

// POST /v1/admin/serviceaccounts → ServiceAccountResponse.
export function registerServiceAccount(input: ServiceAccountInput): Promise<ServiceAccount> {
  return api.post<ServiceAccountResponse>(BASE, { body: toNewRequest(input) }).then(toServiceAccount)
}

// PUT /v1/admin/serviceaccounts/{id} → ServiceAccountResponse.
export function updateServiceAccount(id: string, input: ServiceAccountInput): Promise<ServiceAccount> {
  return api.put<ServiceAccountResponse>(`${BASE}/${id}`, { body: toUpdateRequest(input) }).then(toServiceAccount)
}

// DELETE /v1/admin/serviceaccounts/{id}.
export function deleteServiceAccount(id: string): Promise<void> {
  return api.delete(`${BASE}/${id}`).then(() => undefined)
}

// Same-origin URL of the downloadable JSON key. The browser fetches it directly
// (cookie-authenticated through the BFF), so this is a plain <a href> target.
export function serviceAccountKeyUrl(id: string): string {
  return `/bff${BASE}/${id}/key`
}
